// video.js エントリーポイント（VR なし）。
// ほとんどのページで使用する。VR が必要なページは videojs_with_vr.js を使う。

import videojs from '@/video_player/plugins';
import { createVodSettings, createLiveSettings } from '@/video_player/settings';
import { calc_viewing_time } from '@/video_player/utils';

window.HELP_IMPROVE_VIDEOJS = false;
window.videojs = videojs;
window.calc_viewing_time = calc_viewing_time;
window.createVodSettings = createVodSettings;
window.createLiveSettings = createLiveSettings;
